export enum UserRole {
  User = "User",
  Admin = "Admin",
}

export enum HeaderSlugs {
  Admin = "/admin/users",
  User = "/",
}
